<template>
  <div>
    <v-tabs
      v-model="selectedTab"
      dark
      fixed-tabs
      background-color="white"
      class="tabsHeader"
      transition
    >
      <v-tabs-slider class="tabStyle"></v-tabs-slider>
      <v-tab href="#grid" @click="clickEvent('grid')">
        <img
          class="iconRight icon"
          height="23px"
          width="23px"
          :src="gridHeaderIcon()"
        >
      </v-tab>

      <v-tab href="#list" value="list" @click="clickEvent('list')">
        <img
          class="iconLeft icon"
          height="23px"
          width="22px"
          :src="listHeaderIcon()"
        >
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="selectedTab">
      <v-tab-item :key="1" :value="'grid'" class="swipeArea">
        <v-row ref="gridRef" class="denseClass" dense v-scroll="handleScroll">
          <grid-list
            v-for="(subscribe, index) in source"
            :key="`${subscribe.key}-${index}`"
            :source="subscribe"
            :size="subscribe.length"
          />
        </v-row>
      </v-tab-item>
      <v-tab-item :key="2" :value="'list'">
        <div ref="listRef" v-scroll="handleScroll">
          <publications
            v-for="(subscribe, index) in source"
            :key="`${subscribe.key}-${index}`"
            :source="subscribe"
            :isSingle="true"
            :index="index"
          />
        </div>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>
<script>
import GridList from './gridItems.vue'
import Publications from '../publication'
import { RegisterEvent } from '@/analytics'
import { mapActions } from 'vuex'
import {
  gridActiveIcon,
  gridIcon,
  timelineActiveIcon,
  timelineIcon
} from '@/assets/img/index.js'
export default {
  created: function () {
    this.loading = true
    this.clickEvent(this.selectedTab)
  },
  name: 'mixed-component',
  components: { GridList, Publications },
  beforeMount () {
    this.gridHeaderIcon()
    this.listHeaderIcon()
  },
  data () {
    return {
      alignments: ['start', 'center', 'end'],
      attrs: {
        class: 'mb-6',
        boilerplate: true,
        elevation: 2
      },
      tabs: null,
      selectedTab: 'grid',
      mixed: {
        grid: {
          reference: 'gridRef',
          lastScrollLimit: 0
        },
        list: {
          reference: 'listRef',
          lastScrollLimit: 0
        }
      }
    }
  },
  props: {
    source: {
      type: Array,
      required: true,
      default: []
    },
    size: Number,
    action: Function
  },
  methods: {
    ...mapActions({
      resetVisible: 'RESET_VISIBLE_POSITIONS'
    }),
    clickEvent (value) {
      RegisterEvent('chi_mixed_view', { target_id: value, target: 'view_mode' })
    },
    handleScroll () {
      const currentRef =
        this.selectedTab === 'list' ? this.mixed.list : this.mixed.grid
      let { reference, lastScrollLimit = 0 } = currentRef
      const scrollPos = window.scrollY + window.innerHeight
      const scrollLimit = this.$refs[reference].offsetHeight

      if (
        scrollLimit > lastScrollLimit &&
        scrollPos > scrollLimit - 5 * window.innerHeight
      ) {
        this.next()
        currentRef.lastScrollLimit = scrollLimit
      }
      this.showLast = scrollPos > scrollLimit - 250
    },
    listHeaderIcon () {
      return this.selectedTab === 'list' ? timelineActiveIcon : timelineIcon
    },
    gridHeaderIcon () {
      return this.selectedTab === 'grid' ? gridActiveIcon : gridIcon
    },
    next () {
      this.action()
    }
  },
  mounted () {
    this.resetVisible()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/mixed/MixedView.vue